<template>
    <div>
      <master />
    </div>
  </template>
  
  <script>
  import { mapState } from "vuex";
  import master from "./components/master/index.vue";
  
  export default {
    components: {
      master,
  
    },
    // computed: {
    //   ...mapState({
    //     showSubRetailer: (state) => state.retailerController.showSubRetailer,
    //   }),
    // },
  };
  </script>
  
  <style>
  </style>